module.exports = __webpack_public_path__ + "img/23_60.7b636dea.png";